import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Event Discount',
    field: 'eventDiscount',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'id',
      fk: 'eventDiscountId',
      namespace: 'eventDiscount',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Purchase',
    field: 'purchase',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'id',
      fk: 'purchaseId',
      namespace: 'purchase',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
